export default {
  title: 'Produtos promovidos',
};
